var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4169_16200)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4169_16200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.501953 17.5904V8.25556H5.72125L13.5003 0.476562V25.3694L5.72125 17.5904H-0.501953Z",
    fill: "#2E1654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0557 10.8791L16.172 8.19727C18.2752 9.06852 19.7523 11.1378 19.7455 13.5609C19.7455 15.9773 18.2684 18.0465 16.172 18.9246L15.0557 16.2428C16.1039 15.8003 16.839 14.7657 16.839 13.5609C16.839 12.3493 16.1039 11.3147 15.0557 10.8791Z",
    fill: "#2E1654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7229 3.8418C21.6481 4.75488 23.2631 6.21264 24.368 8.03453C25.4729 9.85641 26.0191 11.9624 25.9389 14.0916C25.8587 16.2208 25.1557 18.2798 23.917 20.0134C22.6782 21.7471 20.9581 23.0792 18.9698 23.845L17.9414 21.1746C19.4074 20.6101 20.6755 19.628 21.5888 18.3498C22.502 17.0717 23.0203 15.5537 23.0794 13.9839C23.1385 12.4142 22.7359 10.8615 21.9213 9.51834C21.1067 8.17514 19.916 7.1004 18.4967 6.42723L19.7229 3.8418Z",
    fill: "#2E1654"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4169_16200",
    x: 0,
    y: 0,
    width: 27,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.21758,
    dy: 1.21758
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.211765 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_4169_16200"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4169_16200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundon);
export default __webpack_public_path__ + "static/media/soundon.93f374b23db520edd8cbe2fec242c30f.svg";
export { ForwardRef as ReactComponent };